module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views/~/babel-runtime/core-js/object/assign.js
// module id = 964
// module chunks = 0